import api from '../../../api/axios';

// Get all service prices
export const getServicePrices = async () => {
  try {
    const response = await api.get('/api/admin/service-prices');
    return response.data;
  } catch (error) {
    console.error('Error fetching service prices:', error);
    throw error;
  }
};

// Get single service price by ID
export const getServicePriceById = async (id: number) => {
  try {
    const response = await api.get(`/api/admin/service-prices/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching service price ${id}:`, error);
    throw error;
  }
};

// Create/update service price
export const saveServicePrice = async (priceData: any) => {
  try {
    const response = await api.post('/api/admin/service-prices', priceData);
    return response.data;
  } catch (error) {
    console.error('Error saving service price:', error);
    throw error;
  }
};

// Delete service price
export const deleteServicePrice = async (id: number) => {
  try {
    const response = await api.delete(`/api/admin/service-prices/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting service price ${id}:`, error);
    throw error;
  }
};

// Get all appointment types without filtering
export const getAppointmentTypes = async () => {
  try {
    // Use the general appointment types endpoint to get all types from Cliniko
    const response = await api.get('/api/appointment-types');
    return response.data;
  } catch (error) {
    console.error('Error fetching appointment types:', error);
    throw error;
  }
};